import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryEmpty: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-empty, power"><path d="M1.75 5.75H19.25V18.25H1.75V5.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M19.25 8.75H22.25V15.25H19.25V8.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBatteryEmpty;
